module.exports = __webpack_public_path__ + "static/media/bipolar.65789005.png";